export default "__VITE_ASSET__CqjRr8gE__"